import { Flex, useMantineTheme, Popover } from '@mantine/core';
import { useState } from 'react';
import classes from './HelpPopover.module.css';
import { type CustomIconName, Icon } from '@/components/Icon/Icon';
import { HelpLink } from '@/components/Link/HelpLink';
import { useClientTerminology } from '@/hooks/useClientTerminology';

export const HelpPopover = ({
  link,
  linkText,
  text,
  fontSize,
  preText,
  onOpen,
  iconName = 'HelpGray',
}: {
  link?: string;
  linkText?: string;
  text?: string;
  fontSize?: string;
  preText?: string;
  onOpen?: () => void;
  iconName?: CustomIconName;
}) => {
  const theme = useMantineTheme();
  const [opened, setOpened] = useState(false);
  const intl = useClientTerminology();
  const isParagraph = !!text;

  return (
    <Popover
      opened={opened}
      onChange={(newOpened) => {
        if (newOpened && !opened && onOpen) {
          onOpen();
        }
        setOpened(newOpened);
      }}
      position={isParagraph ? 'right' : 'top'}
      withArrow
      offset={10}
      classNames={{
        dropdown: isParagraph
          ? `${classes.dropdown} ${classes.dropdownStacked}`
          : classes.dropdown,
        arrow: classes.arrow,
      }}
      styles={{
        dropdown: {
          background: theme.other.overlay.background,
          color: theme.other.mainColor.foreground.onAccent,
          ...theme.other.typography.variants.bodySmallRegular,
          ...(isParagraph ? { width: '340px' } : {}),
        },
        arrow: {
          background: theme.other.overlay.background,
        },
      }}
    >
      <Popover.Target>
        <Flex
          onClick={() => {
            const newOpened = !opened;
            if (newOpened && onOpen) {
              onOpen();
            }
            setOpened(newOpened);
          }}
          className={classes.helpIcon}
        >
          <Icon name={iconName} size={16}></Icon>
        </Flex>
      </Popover.Target>
      <Popover.Dropdown>
        {link ? (
          <>
            <span>
              {text ??
                preText ??
                intl.formatMessage({ id: 'map.legend.learnMoreAbout' })}
            </span>
            <HelpLink
              link={link}
              text={linkText}
              textSize={fontSize}
              bright={true}
            />
          </>
        ) : (
          <span>{text}</span>
        )}
      </Popover.Dropdown>
    </Popover>
  );
};
